<div>
    <a *ngIf="hrefLink.length != 0" href="{{hrefLink}}">{{name}}</a>
    <div *ngIf="hrefLink.length === 0">{{name}}</div>
</div>